import { useReactiveVar } from '@apollo/client';
import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AppRoutesEnum } from '@constants/enums/Routes.enum';
import { authTokenVar } from '@gql/vars';

export const NonAuthGuard: FC = () => {
  const authToken = useReactiveVar(authTokenVar);

  if (authToken) {
    return <Navigate to={AppRoutesEnum.DASHBOARD_ROUTE} replace />;
  }

  return <Outlet />;
};
